import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import Table from "../../../../core/common/dataTable/index";
import { DatePicker, Drawer, message } from "antd";
import CollapseHeader from "../../../../core/common/collapse-header/collapse-header";
import { createLeaveRequest, deleteLeaveRequest, fetchAllLeaveRequests, fetchAllLeaveRequestsWithCancelation, fetchEmployeeLeaveAssignById, updateLeaveRequest, } from "../../../../core/data/redux/attendance/leave/leaveAction";
import { fetchAllLeaveTypes } from "../../../../core/data/redux/attendance/leaveTypes/LeaveTypeActions";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../../core/data/redux/store";
import DeleteModal1 from "../../../../core/modals/deleteModal1";
import { getEmployees } from "../../../../core/data/redux/employee/employeeAction";
import { formatDate } from "../../../../core/utils/configFormatters";
import { filterData } from "../../../../core/common/GlobalFunctions/tableFilters";
import { exportToCSV, exportToExcel, exportToPDF, } from "../../../../core/common/GlobalFunctions/exportTableData";
import { fetchAllLeaveCountByEmployeeId, fetchAllLeaveReport } from "../../../../core/data/redux/reports/leave_reports/leavereports.Action";
import { useAppConfig } from "../../../../customhooks/useAppConfig";
import { filterByStatus } from "../../../../core/utils/filterActiveData";
import { decryptData } from "../../../../core/utils/encryptUtils";
import LeaveCancellationForm from "./leavecancellation";

const leaveStatus = [
  { value: "Pending", label: "Pending" },
  { value: "Approved", label: "Approved" },
  { value: "Rejected", label: "Rejected" },
];

const LeaveAdmin = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [selectedSort, setSelectedSort] = useState<any>("");
  const [tableKey, setTableKey] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<boolean>(false);
  const [modalType, setModalType] = useState<"edit" | "create" | "">("");
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const { user } = useSelector((state: any) => state.auth);
  const { leaveTypes } = useSelector((state: any) => state.attendance.leaveTypes);
  const { leaveRequests, loadingStates } = useSelector((state: any) => state.attendance.leaveRequests);
  const isLoading = modalType === "edit" ? loadingStates.update : loadingStates.create
  const { employees } = useSelector((state: any) => state.employee);
  const employeeData = employees ? employees : [];
  const LeaveTypesData = leaveTypes ? leaveTypes : [];
  const leaveRequestId = Number(selectedRowData?.Id);
  const [errors, setErrors] = useState<any>({});
  const [employeeassignleave, setemployeeassignleave] = useState<any>([])
  const [leavecountDetails, setleavecountDetails] = useState<any>(null);
  const [leaveRequestData, setLeaveRequestData] = useState({
    selectEmployeeName: "",
    selectedLeaveType: "",
    LeaveMode: "",
    fromDate: null as dayjs.Dayjs | null,
    toDate: null as dayjs.Dayjs | null,
    reason: "",
    noOfDays: 0,
    remainingDays: 0,
    LeaveRequestStatus: "Pending",
  });
  const [alldata, setalldata] = useState<any>()
  const [isCancellationModalVisible, setIsCancellationModalVisible] = useState(false);
  const [count, setcount] = useState<any>("")
  // Permission
  const encryptedPermissions = localStorage.getItem('currentPermissions');
  const permissions: string[] = Array.isArray(decryptData(encryptedPermissions || '')) ? decryptData(encryptedPermissions || '') : [];

  const canAdd =
    permissions.includes("Add") || permissions.includes("AllowAll");
  const canView =
    permissions.includes("View") || permissions.includes("AllowAll");
  const canEdit =
    permissions.includes("Edit") || permissions.includes("AllowAll");
  const canDelete =
    permissions.includes("Delete") || permissions.includes("AllowAll");
  const canExport =
    permissions.includes("Export") || permissions.includes("AllowAll");


  const activeLeaveType = filterByStatus(LeaveTypesData, 'active', 'Status');
  const activeEmployeeData = filterByStatus(employeeData, 'active', 'employee_status');

  useEffect(() => {
    if (modalType === "edit" && leaveRequestId && selectedRowData) {
      setLeaveRequestData({
        selectEmployeeName: selectedRowData.EmployeeId || "",
        selectedLeaveType: selectedRowData.LeaveTypeId || "",
        LeaveMode: selectedRowData.LeaveMode || "",
        fromDate: selectedRowData.FromDate ? dayjs(selectedRowData.FromDate) : null,
        toDate: selectedRowData.ToDate ? dayjs(selectedRowData.ToDate) : null,
        reason: selectedRowData.Description || "",
        noOfDays: selectedRowData.Duration || 0,
        remainingDays: Number(leaveRequestData?.remainingDays),
        LeaveRequestStatus: selectedRowData.LeaveRequestStatus,
      });
    }
  }, [selectedRowData, modalType]);

  useEffect(() => {
    const { fromDate, toDate, selectedLeaveType, LeaveMode } = leaveRequestData;

    if (!selectedLeaveType || !fromDate || !toDate) return;

    const selectedLeave = employeeassignleave.find(
      (item: any) => String(item.LeaveTypeId) === String(selectedLeaveType)
    );

    if (!selectedLeave) return;

    const from = dayjs(fromDate);
    const to = dayjs(toDate);

    if (to.isBefore(from)) return;
    let days = to.diff(from, "day") + 1;
    if (LeaveMode === "Half Day") {
      days = days * 0.5;
    }

    const remaining = Math.max(selectedLeave.LeaveQuantity - days, 0);

    setLeaveRequestData((prev) => ({
      ...prev,
      noOfDays: days,
      remainingDays: remaining,
    }));
  }, [
    leaveRequestData.fromDate,
    leaveRequestData.toDate,
    leaveRequestData.selectedLeaveType,
    leaveRequestData.LeaveMode,
    employeeassignleave,
  ]);




  useEffect(() => {
    if (!leaveTypes.length) {
      dispatch(fetchAllLeaveTypes());
    }
    if (!employees.length) {
      dispatch(getEmployees());
    }
    dispatch(fetchAllLeaveRequestsWithCancelation())
      .then((res) => {
        setalldata(res.payload.data)
      })
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchAllLeaveReport("2025")).then((res) => {
      setleavecountDetails(res.payload.data);
    });

  }, [])


  useEffect(() => {
    const employeeId = leaveRequestData.selectEmployeeName;
    if (employeeId) {
      dispatch(fetchEmployeeLeaveAssignById(employeeId)).then((res) => {
        if (res.meta.requestStatus === "fulfilled") {
          setemployeeassignleave(res.payload.data || []);
        } else {
          setemployeeassignleave([]);
        }
      });

      dispatch(fetchAllLeaveCountByEmployeeId(employeeId))
        .then((res) => {
          setcount(res?.payload?.data)
        })
    } else {
      setemployeeassignleave([]);
    }
  }, [leaveRequestData.selectEmployeeName, dispatch]);



  // const handleInputChange = (e: any, field: string) => {
  //   const { value } = e.target;
  //   setLeaveRequestData((prevState) => ({
  //     ...prevState,
  //     [field]: value,
  //   }));
  // };

  const handleInputChange = (e: any, field: string) => {
    const { value } = e.target;


    if (field === "selectedLeaveType") {
      const selectedLeave = employeeassignleave.find(
        (item: any) => String(item.LeaveTypeId) === String(value)
      );

      setLeaveRequestData((prevState: any) => ({
        ...prevState,
        [field]: value,
        remainingDays: selectedLeave ? selectedLeave.Balance : 0,
      }));
    }

    else if (field === "selectEmployeeName") {
      setLeaveRequestData((prevState: any) => ({
        ...prevState,
        [field]: value,
        selectedLeaveType: "",
        remainingDays: 0,
      }));
    }

    else {
      setLeaveRequestData((prevState: any) => ({
        ...prevState,
        [field]: value,
      }));
    }
  };


  const handleDateChange = (date: dayjs.Dayjs | null, field: string) => {
    setLeaveRequestData((prevState) => ({
      ...prevState,
      [field]: date,
    }));
  };

  const showModal = (type: "edit" | "create") => {
    setModalType(type);
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    setModalType("");
    resetForm();
    setErrors({})
  };

  const handleEditlevaeRequest = (record: any): void => {
    setSelectedRowData(record);
    setErrors({})
  };

  const resetForm = () => {
    setLeaveRequestData({
      selectEmployeeName: "",
      selectedLeaveType: "",
      LeaveMode: "",
      fromDate: null,
      toDate: null,
      reason: "",
      noOfDays: 0,
      remainingDays: 0,
      LeaveRequestStatus: "Pending",
    });
    setErrors({})
  };

  const validateForm = () => {
    let formIsValid = true;

    let newErrors: any = {
      selectEmployeeName: "",
      selectedLeaveType: "",
      fromDate: "",
      LeaveMode: "",
      toDate: "",
      reason: "",
      noOfDays: "",
      remainingDays: "",
      LeaveRequestStatus: "",
    };

    if (!leaveRequestData.selectEmployeeName) {
      formIsValid = false;
      newErrors.selectEmployeeName = "Please select an employee.";
    }
    if (!leaveRequestData.selectedLeaveType) {
      formIsValid = false;
      newErrors.selectedLeaveType = "Please select a leave type.";
    }
    if (!leaveRequestData.fromDate) {
      formIsValid = false;
      newErrors.fromDate = "From date is required.";
    }
    if (!leaveRequestData.toDate) {
      formIsValid = false;
      newErrors.toDate = "To date is required.";
    }
    if (!leaveRequestData.LeaveMode) {
      formIsValid = false;
      newErrors.LeaveMode = "Leave taken is required.";
    }
    if (!leaveRequestData.LeaveRequestStatus) {
      formIsValid = false;
      newErrors.LeaveRequestStatus = "Status is required.";
    }
    if (
      leaveRequestData.fromDate &&
      leaveRequestData.toDate &&
      dayjs(leaveRequestData.fromDate).isAfter(dayjs(leaveRequestData.toDate))
    ) {
      formIsValid = false;
      newErrors.toDate = "To date cannot be earlier than from date.";
    }

    if (!leaveRequestData.reason.trim()) {
      formIsValid = false;
      newErrors.reason = "Reason is required.";
    }

    if (!leaveRequestData.noOfDays || leaveRequestData.noOfDays <= 0) {
      formIsValid = false;
      newErrors.noOfDays = "Number of days must be greater than 0.";
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    const LeaveRequestData = {
      LeaveTypeId: Number(leaveRequestData.selectedLeaveType),
      FromDate: leaveRequestData.fromDate
        ? leaveRequestData.fromDate.toISOString()
        : "",
      ToDate: leaveRequestData.toDate
        ? leaveRequestData.toDate.toISOString()
        : "",
      Reason: leaveRequestData.reason,
      LeaveMode: leaveRequestData.LeaveMode,
      Duration: leaveRequestData.noOfDays,
      CreatedBy: user?.UserId,
      ModifiedBy: user?.UserId,
      EmployeeId: Number(leaveRequestData.selectEmployeeName),
      LeaveRequestStatus: leaveRequestData.LeaveRequestStatus,
      Description: leaveRequestData.reason,
    };

    if (modalType === "create") {
      const result = await dispatch(createLeaveRequest(LeaveRequestData));
      if (result.meta.requestStatus === "fulfilled") {
        message.success("Leave request created successfully");
        resetForm();
        await dispatch(fetchAllLeaveRequestsWithCancelation())
          .then((res) => {
            setalldata(res.payload.data)
          })
        setTableKey((prevKey) => prevKey + 1);
      } else {
        message.warning(result.payload.message);
      }
    } else if (modalType === "edit" && leaveRequestId) {
      const result = await dispatch(
        updateLeaveRequest({ leaveRequestId, data: LeaveRequestData })
      );
      if (result.meta.requestStatus === "fulfilled") {
        message.success("Leave request updated successfully");
        await dispatch(fetchAllLeaveRequestsWithCancelation())
          .then((res) => {
            setalldata(res.payload.data)
          })
        setTableKey((prevKey) => prevKey + 1);
        resetForm();
      } else if (result.meta.requestStatus === "rejected") {
        message.warning(result.payload.error);
      }
    }
    handleCancel();
  };

  const handleDeleteLeave = async (designationId: number) => {
    try {
      const result = await dispatch(deleteLeaveRequest(designationId));
      if (result.meta.requestStatus === "fulfilled") {
        message.success("Leave deleted successfully");
        setIsDeleteModalVisible(false);
        await dispatch(fetchAllLeaveRequestsWithCancelation())
          .then((res) => {
            setalldata(res.payload.data)
          })
        setTableKey((prevKey) => prevKey + 1);
      } else {
        message.warning(result.payload.error);
      }
    } catch (error) {
      message.error("Something went wrong");
    }
  };

  const data = alldata ? alldata : [];

  const exportLeaveAdmin = data.map((item: any) => ({
    employeeName: item.employeeName || "N/A",
    // Description: item.Description || "N/A",
    FromDate: item.FromDate ? new Date(item.FromDate).toLocaleDateString("en-IN") : "N/A",
    ToDate: item.ToDate ? new Date(item.ToDate).toLocaleDateString("en-IN") : "N/A",
    Duration: item.Duration || "N/A",
    LeaveRequestStatus: item.LeaveRequestStatus || "Pending",
    Cancellation_status: item.Cancellation_status || "N/A",
    CreatedAt: item.CreatedAt ? new Date(item.CreatedAt).toLocaleDateString("en-IN") : "N/A",
    // CreatedBy: item.CreatedBy || "N/A",
    ModifiedAt: item.ModifiedAt ? new Date(item.ModifiedAt).toLocaleDateString("en-IN") : "N/A",
    // ModifiedBy: item.ModifiedBy || "N/A",
    LeaveMode: item.LeaveMode || "N/A",
    LeaveType: item.LeaveType || "N/A",
  }));


  const filteredData = useMemo(() => {
    const filters =
      selectedStatus && selectedStatus !== "All"
        ? { LeaveRequestStatus: selectedStatus }
        : {};
    return filterData(
      data || [],
      filters,
      "CreatedAt",
      "CreatedAt",
      selectedSort
    );
  }, [data, selectedStatus, selectedSort, dispatch]);

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [selectedStatus, selectedSort, alldata, dispatch]);

  const config = useAppConfig();
  if (!config) return null;

  const columns = [
    {
      title: "Employee",
      dataIndex: "employeeName",
      render: (text: string, record: any) => (
        <div className="d-flex align-items-center">
          <Link to={all_routes.employeedetails} className="avatar avatar-md">
            <img
              src={record.PictureURL ?? "https://cdn-icons-png.flaticon.com/512/149/149071.png"}
              alt="img"
              className="img-fluid rounded-circle"
            />
          </Link>
          <div className="ms-2">
            <p className="text-dark mb-0">
              <Link to="#">{record.employeeName}</Link>
            </p>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => a.employeeName.length - b.employeeName.length,
    },
    {
      title: "Leave Type",
      dataIndex: "LeaveType",
      render: (text: String, record: any) => (
        <div className="d-flex align-items-center">
          <p className="fs-14 fw-medium d-flex align-items-center mb-0">
            {record.LeaveType}
          </p>
          <Link
            to="#"
            className="ms-2"
            data-bs-toggle="tooltip"
            data-bs-placement="right"
            data-bs-title="I am currently experiencing a fever and design & Development"
          >
            <i className="ti ti-info-circle text-info" />
          </Link>
        </div>
      ),
      sorter: (a: any, b: any) => a.LeaveType.length - b.LeaveType.length,
    },
    {
      title: "From",
      dataIndex: "FromDate",
      render: (text: string) => formatDate(text, config),
      sorter: (a: any, b: any) => a.FromDate.length - b.FromDate.length,
    },
    {
      title: "To",
      dataIndex: "ToDate",
      render: (text: string) => formatDate(text, config),
      sorter: (a: any, b: any) => a.ToDate.length - b.ToDate.length,
    },
    {
      title: "No of Days",
      dataIndex: "Duration",
      sorter: (a: any, b: any) => a.Duration.length - b.Duration.length,
    },
    {
      title: "Status",
      dataIndex: "LeaveRequestStatus",
      render: (text: string, record: any) => {
        const badgeClass =
          text === "Pending"
            ? "badge-warning"
            : text === "Approved"
              ? "badge-success"
              : text === "Rejected"
                ? "badge-danger"
                : text === "Cancelled"
                  ? "badge-secondary"
                  : "";

        return (
          <span
            className={`badge ${badgeClass} d-inline-flex align-items-center badge-xs`}
          >
            <i className="ti ti-point-filled me-1" />
            {text}
          </span>
        );
      },
    },
    {
      title: "Cancellation_Status",
      dataIndex: "Cancellation_status",
      render: (text: string) => {
        const badgeClass =
          text === "Pending"
            ? "badge-warning"
            : text === "Approved"
              ? "badge-success"
              : text === "Rejected"
                ? "badge-danger"
                : "";

        return (
          <span
            className={`badge ${badgeClass} d-inline-flex align-items-center badge-xs`}
          >
            <i className="ti ti-point-filled me-1" />
            {text || "N/A"}
          </span>
        );
      },
      sorter: (a: any, b: any) =>
        (a.Cancellation_status || "").localeCompare(b.Cancellation_status || ""),
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (text: string, record: any) => {
        const isDisabled =
          record.LeaveRequestStatus === "Approved" ||
          record.LeaveRequestStatus === "Cancelled";

        const today = dayjs();

        const canCancel =
          record.LeaveRequestStatus === "Approved" &&
          !["Pending", "Approved", "Rejected"].includes(record.Cancellation_status) &&
          (
            // Before Leave Start Date
            (today.isSameOrBefore(dayjs(record.ToDate), "day") &&
              today.isBefore(dayjs(record.FromDate), "day")) ||

            // During Leave Dates
            (today.isSameOrAfter(dayjs(record.FromDate), "day") &&
              today.isSameOrBefore(dayjs(record.ToDate), "day"))
          );

        return (
          <div className="action-icon d-inline-flex">
            <button
              className="me-2"
              onClick={() => {
                if (isDisabled || !canEdit) return;
                showModal("edit");
                handleEditlevaeRequest(record);
              }}
              disabled={isDisabled || !canEdit}
              style={{
                cursor: isDisabled || !canEdit ? "not-allowed" : "pointer",
                opacity: isDisabled || !canEdit ? 0.5 : 1,
              }}
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title={
                isDisabled
                  ? "Action Disabled (Status Locked)"
                  : !canEdit
                    ? "Permission Denied"
                    : "Edit"
              }
            >
              <i className="ti ti-edit" />
            </button>

            <button
              className="me-2"
              onClick={() => {
                if (isDisabled || !canDelete || record.status === "inactive") return;
                setSelectedRowData(record);
                handleEditlevaeRequest(record);
                setIsDeleteModalVisible(true);
              }}
              disabled={isDisabled || !canDelete || record.status === "inactive"}
              style={{
                cursor:
                  isDisabled || !canDelete || record.status === "inactive"
                    ? "not-allowed"
                    : "pointer",
                opacity:
                  isDisabled || !canDelete || record.status === "inactive" ? 0.5 : 1,
              }}
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title={
                isDisabled
                  ? "Action Disabled (Status Locked)"
                  : !canDelete
                    ? "Permission Denied"
                    : record.status === "inactive"
                      ? "Item is inactive"
                      : "Delete"
              }
            >
              <i className="ti ti-trash" />
            </button>

            <button
              onClick={() => {
                if (!canCancel) return;
                setSelectedRowData(record);
                setIsCancellationModalVisible(true);
              }}
              disabled={!canCancel}
              style={{
                cursor: "pointer",
                border: "none",
                background: "transparent",
                padding: 0,
                opacity: 1,
              }}
              title={
                !canCancel
                  ? record.Cancellation_status === "Pending"
                    ? "Cancellation request already submitted"
                    : record.Cancellation_status === "Approved"
                      ? "Cancellation already approved"
                      : "Cancellation not allowed"
                  : "Request Cancellation"
              }
            >
              <i
                className="fa-solid fa-ban text-grey"
                style={{ fontSize: "16px", width: "16px", height: "16px" }}
              ></i>
            </button>
          </div>
        );
      },
    }
  ];

  const selectLevaeChoose = [
    { value: "Full Day", label: "Full Day" },
    { value: "Half Day", label: "Half Day" },
  ];

  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body;
  };

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Leaves</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Attendance</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Leaves
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              {canExport && (
                <div className="me-2 mb-2">
                  <div className="dropdown">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      <i className="ti ti-file-export me-1" />
                      Export
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <button
                          onClick={() => exportToCSV(exportLeaveAdmin, "leave_data")}
                          className="dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-pdf me-1" />
                          Export as CSV
                        </button>
                      </li>
                      <li>
                        <button
                          onClick={() => exportToExcel(exportLeaveAdmin, "leave_data")}
                          className="dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </button>
                      </li>
                      <li>
                        <button
                          onClick={() => exportToPDF(exportLeaveAdmin, "leave_data")}
                          className="dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as PDF{" "}
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
              <div className="mb-2">
                {canAdd && (
                  <button
                    onClick={() => showModal("create")}
                    className="btn btn-primary d-flex align-items-center"
                  >
                    <i className="ti ti-circle-plus me-2" />
                    Add Leave
                  </button>
                )}
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Leaves Info */}
          <div className="row">
            <div className="col-xl-3 col-md-6">
              <div className="card bg-green-img">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0 me-2">
                        <span className="avatar avatar-md rounded-circle bg-white d-flex align-items-center justify-content-center">
                          <i className="ti ti-user-check text-success fs-18" />
                        </span>
                      </div>
                    </div>
                    <div className="text-start">
                      <p className="mb-1">Total Leaves</p>
                      <h4>{leavecountDetails ? leavecountDetails?.[0].TotalLeaves : 0}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-6">
              <div className="card bg-pink-img">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0 me-2">
                        <span className="avatar avatar-md rounded-circle bg-white d-flex align-items-center justify-content-center">
                          <i className="ti ti-user-edit text-pink fs-18" />
                        </span>
                      </div>
                    </div>
                    <div>
                      <p className="fs-12 fw-normal mb-1 text-truncate">
                        Rejected Leaves
                      </p>
                      <h4>{leavecountDetails?.[0].RejectedLeaves || 0}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-6">
              <div className="card bg-yellow-img">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0 me-2">
                        <span className="avatar avatar-md rounded-circle bg-white d-flex align-items-center justify-content-center">
                          <i className="ti ti-user-exclamation text-warning fs-18" />
                        </span>
                      </div>
                    </div>
                    <div>
                      <p className="fs-12 fw-normal mb-1 text-truncate">
                        Approved Leaves
                      </p>
                      <h4>{leavecountDetails?.[0].ApprovedLeaves || 0}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-6">
              <div className="card bg-blue-img">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0 me-2">
                        <span className="avatar avatar-md rounded-circle bg-white d-flex align-items-center justify-content-center">
                          <i className="ti ti-user-question text-info fs-18" />
                        </span>
                      </div>
                    </div>
                    <div>
                      <p className="fs-12 fw-normal mb-1 text-truncate">
                        Pending Requests
                      </p>
                      <h4>{leavecountDetails?.[0].PendingLeaves || 0}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* /Leaves Info */}
          {/* Leaves list */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Leave List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedStatus
                      ? selectedStatus.charAt(0).toUpperCase() +
                      selectedStatus.slice(1)
                      : "Select Status"}
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("All")}
                        className="dropdown-item rounded-1"
                      >
                        All
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("Pending")}
                        className="dropdown-item rounded-1"
                      >
                        Pending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("Approved")}
                        className="dropdown-item rounded-1"
                      >
                        Approved
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("Rejected")}
                        className="dropdown-item rounded-1"
                      >
                        Rejected
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedSort
                      ? `Sort By : ${selectedSort}`
                      : "Sort By : Last 7 Days"}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Recently Added")}
                        className="dropdown-item rounded-1"
                      >
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Ascending")}
                        className="dropdown-item rounded-1"
                      >
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Descending")}
                        className="dropdown-item rounded-1"
                      >
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last Month")}
                        className="dropdown-item rounded-1"
                      >
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last 7 Days")}
                        className="dropdown-item rounded-1"
                      >
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table
                key={tableKey}
                dataSource={filteredData}
                columns={columns}
                Selection={true}
              />
            </div>
          </div>
          {/* /Leaves list */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Add Leaves */}
      <Drawer
        title={modalType === "edit" ? "Edit leave" : "Add leave"}
        placement="right"
        width={650}
        onClose={handleCancel}
        visible={isModalVisible}
        style={{ marginTop: 50, paddingBottom: 50 }}
      >
        <form>
          <div className="modal-body pb-0">
            {employeeassignleave?.length > 0 && (
              <div className="mb-4" style={{ marginTop: "20px" }}>
                <h5 className="fw-bold mb-3">Leave Details</h5>
                <div className="table-responsive">
                  <table className="table table-bordered table-hover table-sm">
                    <thead className="table-light">
                      <tr>
                        <th>Leave Type</th>
                        <th>Quantity</th>
                        <th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {employeeassignleave?.map((leave: any) => (
                        <tr key={leave.Id}>
                          <td>{leave.LeaveTypeName}</td>
                          <td>{leave.LeaveQuantity}</td>
                          <td>{new Date(leave.Date).toLocaleDateString()}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

              </div>
            )}
            <div className="row">
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Employee Name <span className="text-danger"> *</span>
                  </label>
                  <select
                    className="form-control"
                    value={leaveRequestData.selectEmployeeName}
                    onChange={(e) => handleInputChange(e, "selectEmployeeName")}
                  >
                    <option value="">Select Employee Name</option>
                    {[...activeEmployeeData]
                      .sort((a, b) => a.Name.localeCompare(b.Name))
                      .map((emp: any) => (
                        <option key={emp.EmployeeID} value={emp.EmployeeID}>
                          {emp.Name}
                        </option>
                      ))}
                  </select>
                  {errors.selectEmployeeName && (
                    <div style={{ color: "red" }}>
                      {errors.selectEmployeeName}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">
                    Leave Type <span className="text-danger"> *</span>
                  </label>
                  <select
                    className="form-control"
                    value={leaveRequestData.selectedLeaveType}
                    onChange={(e) => handleInputChange(e, "selectedLeaveType")}
                  >
                    <option value="">Select Leave Type</option>
                    {employeeassignleave && employeeassignleave?.map((leaveType: any) => (
                      <option key={leaveType.LeaveTypeId} value={leaveType.LeaveTypeId}>
                        {leaveType.LeaveTypeName}
                      </option>
                    ))}
                  </select>
                  {errors.selectedLeaveType && (
                    <div style={{ color: "red" }}>
                      {errors.selectedLeaveType}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">
                    Leave taken <span className="text-danger"> *</span>
                  </label>
                  <select
                    className="form-control"
                    value={leaveRequestData.LeaveMode}
                    onChange={(e) => handleInputChange(e, "LeaveMode")}
                  >
                    <option value="">Select Leave</option>
                    {selectLevaeChoose.map((leave: any) => (
                      <option key={leave.value} value={leave.value}>
                        {leave.value}
                      </option>
                    ))}
                  </select>
                  {errors.LeaveMode && (
                    <div style={{ color: "red" }}>{errors.LeaveMode}</div>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">
                    From <span className="text-danger"> *</span>
                  </label>
                  <div className="input-icon-end position-relative">
                    <DatePicker
                      className="form-control datetimepicker"
                      format="DD-MM-YYYY"
                      getPopupContainer={getModalContainer}
                      value={
                        leaveRequestData.fromDate
                          ? dayjs(leaveRequestData.fromDate)
                          : null
                      }
                      onChange={(date) => handleDateChange(date, "fromDate")}
                      placeholder="DD-MM-YYYY"
                    />

                    <span className="input-icon-addon">
                      <i className="ti ti-calendar text-gray-7" />
                    </span>
                  </div>
                  {errors.fromDate && (
                    <div style={{ color: "red" }}>{errors.fromDate}</div>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">
                    To <span className="text-danger"> *</span>
                  </label>
                  <div className="input-icon-end position-relative">
                    <DatePicker
                      className="form-control datetimepicker"
                      format="DD-MM-YYYY"
                      getPopupContainer={getModalContainer}
                      value={
                        leaveRequestData.toDate
                          ? dayjs(leaveRequestData.toDate)
                          : null
                      } // Use dayjs
                      onChange={(date) => handleDateChange(date, "toDate")}
                      placeholder="DD-MM-YYYY"
                    />
                    <span className="input-icon-addon">
                      <i className="ti ti-calendar text-gray-7" />
                    </span>
                  </div>
                  {errors.toDate && (
                    <div style={{ color: "red" }}>{errors.toDate}</div>
                  )}
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">
                    No of Days <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={leaveRequestData.noOfDays}
                    onChange={(e) => handleInputChange(e, "noOfDays")}
                    disabled
                  />
                  {errors.noOfDays && (
                    <div style={{ color: "red" }}>{errors.noOfDays}</div>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">
                    Remaining Days <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={leaveRequestData?.remainingDays}
                    disabled
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Status<span className="text-danger"> *</span>
                  </label>
                  <select
                    className="form-control"
                    value={leaveRequestData.LeaveRequestStatus}
                    onChange={(e) => handleInputChange(e, "LeaveRequestStatus")}
                  >
                    <option value="">Select Status</option>
                    {leaveStatus.map((status: any) => (
                      <option key={status.value} value={status.value}>
                        {status.label}
                      </option>
                    ))}
                  </select>
                  {errors.LeaveRequestStatus && (
                    <div style={{ color: "red" }}>{errors.LeaveRequestStatus}</div>

                  )}
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Reason <span className="text-danger"> *</span>
                  </label>
                  <textarea
                    className="form-control"
                    rows={2}
                    value={leaveRequestData.reason}
                    onChange={(e) => handleInputChange(e, "reason")}
                  />
                  {errors.reason && (
                    <div style={{ color: "red" }}>{errors.reason}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light me-2"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSubmit} disabled={isLoading}
            >{isLoading && <span className="spinner-border spinner-border-sm me-2" />}
              {modalType === "edit" ? "Update Leave" : "Add Leave"}
            </button>
          </div>
        </form>
      </Drawer>
      {/* /Add Leaves */}
      <DeleteModal1
        isVisible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onConfirm={() =>
          selectedRowData?.Id && handleDeleteLeave(selectedRowData.Id)
        }
      />

      <Drawer
        title="Cancel Leave"
        placement="right"
        open={isCancellationModalVisible}
        onClose={() => setIsCancellationModalVisible(false)}
        width={500}
      >
        <LeaveCancellationForm
          selectedRowData={selectedRowData}
          count={count}
          onClose={() => setIsCancellationModalVisible(false)}
        />

      </Drawer>
    </>
  );
};

export default LeaveAdmin;
